import { Component } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-package-service-item-pop-up',
    templateUrl: './package-service-item-pop-up.component.html',
    standalone: false
})
export class PackageServiceItemPopUpComponent {

  configList = {
    "viewAll": true,
    "hideSearchBox": true,
    "hideResult": true,
    "allowPagination": false,
    "print_allowed": false
  }
  dataListForDhsGRid: any;
  segmentData: any
  fields = []
  examinationData: any;

  constructor(
    public baseService: BaseService,
    public alertsService: AlertsService,
    private loaderService: LoaderService,
    public dialogConfig: DialogConfig,
    public dialog: DialogRef
  ){}

  ngOnInit(): void {
    if (this['data'] == undefined) {
      if (this.dialogConfig != undefined) {
        this['data'] = this.dialogConfig;
      }
    }
    if(this['data'].employee_id && this['data'].orderId){
      this.getPatientDetails(this['data'].employee_id, this['data'].orderId, this['data'].id);
    }
    if(this['data'].data){
      this.segmentData = this['data'].data;
      this.examinationData = this.segmentData[this.segmentData.examination_type]
      if(this.examinationData.id){
        delete this.examinationData.id
      }
      if(this.examinationData.extra_data ){
        delete this.examinationData.extra_data
      }
      const hiddenKeys = ['g_created_by_id','g_created_by_name','g_created_by_role','g_created_by_role_type',
        'g_creation_time','g_modified_by_id','g_modified_by_name','g_modify_time'];
      
    hiddenKeys.forEach(key => {
      if (key in this.examinationData) {
        delete this.examinationData[key];
      }
    });
      this.loaderService.hideSpinner();
    }
  }
  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  getFormattedRE(value: any): string {
    if (!value) {
      return '';
    }
    if (this.isArray(value)) {
      // Filter out empty strings, then map and join
      return value
        .map((item: any) => item?.RE)
        .filter((val: string) => val !== '' && val !== null && val !== undefined)
        .join(', ');
    } else {
      // Handle single object case
      return value?.RE === '' ? '' : value?.RE || '';
    }
  }

  // New helper function for LE values
  getFormattedLE(value: any): string {
    if (!value) {
      return '';
    }
    if (this.isArray(value)) {
      // Filter out empty strings, then map and join
      return value
        .map((item: any) => item?.LE)
        .filter((val: string) => val !== '' && val !== null && val !== undefined)
        .join(', ');
    } else {
      // Handle single object case
      return value?.LE === '' ? '' : value?.LE || '';
    }
  }
  convertString(string) {
    let result = string.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    if(result == 'Hirscheberg'){
      result = 'Hirschberg'
    }
    else if(result == 'Conjuctiva'){
      result = 'Conjunctiva'
    }
    else if(result == 'Fundus Bk Grnd'){
      result = 'Fundus Background'
    }
    else if(result == 'Blood Vessels Veins'){
      result = 'Blood Vessels(Veins)'
    }
    return result
  }

  copyHistory(){
    this.dialog.close(this.segmentData);
  }

  close(){
    this.dialog.close();
  }

  copy(id){
    let examId = this.examinationData;
    for (var key in examId) {
      if(key != id){
        delete examId[key]
      }
    }
    let data = {
      "examination_type" : this.segmentData.examination_type,
      [this.segmentData.examination_type] : examId
    }
    this.dialog.close(data);
  }
  
  getPatientDetails(employee_id: any, orderId, id: any){
    let args = "orderId:"+orderId+",employeeId:"+employee_id+",pmeId:"+id;
    this.baseService.get("GET_BY_EMPLOYEE_ID", args, "pme_temp_health_assessment", "data-onboarding").subscribe(
      (res) => {
        if(res.errCode == -1){
          this.alertsService.error(res.message)
        }
        if(res.errCode == 0 && res.resource && res.resource.length != 0){
          this.dataListForDhsGRid = {...res.resource[0].observation_data,...res.resource[0].emr_data}
        }
      }
    )
  }

}
